{
  "_note": "REVIEW NEEDED: IRB/regulatory terminology must be reviewed by a qualified German-speaking clinical research professional before activating locale=de in production.",
  "app": {
    "name": "OneVerse",
    "loading": "Laden...",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "delete": "Löschen",
    "confirm": "Bestätigen",
    "submit": "Einreichen",
    "edit": "Bearbeiten",
    "close": "Schließen",
    "back": "Zurück",
    "next": "Weiter",
    "search": "Suchen",
    "filter": "Filtern",
    "export": "Exportieren",
    "yes": "Ja",
    "no": "Nein",
    "required": "Pflichtfeld",
    "optional": "Optional",
    "none": "Keine",
    "unknown": "Unbekannt",
    "error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    "powered_by": "Bereitgestellt von {{name}}"
  },
  "nav": {
    "home": "Startseite",
    "dashboard": "Dashboard",
    "submissions": "Einreichungen",
    "studies": "Studien",
    "sites": "Standorte",
    "users": "Benutzer",
    "settings": "Einstellungen",
    "notifications": "Benachrichtigungen",
    "admin": "Administration",
    "help": "Hilfe",
    "sign_out": "Abmelden",
    "logout": "Abmelden",
    "expand_sidebar": "Seitenleiste erweitern",
    "collapse_sidebar": "Seitenleiste einklappen"
  },
  "auth": {
    "sign_in": "Anmelden",
    "sign_in_button": "Anmelden",
    "sign_out": "Abmelden",
    "email": "E-Mail-Adresse",
    "email_placeholder": "E-Mail-Adresse eingeben",
    "password": "Passwort",
    "password_placeholder": "Passwort eingeben",
    "forgot_password": "Passwort vergessen?",
    "reset_password": "Passwort zurücksetzen",
    "enter_reset_code": "Zurücksetzungscode eingeben",
    "reset_code_instructions": "Geben Sie Ihre E-Mail-Adresse ein, und wir senden Ihnen einen Code zum Zurücksetzen Ihres Passworts.",
    "new_code_instructions": "Geben Sie den Code und Ihr neues Passwort ein.",
    "send_reset_code": "Zurücksetzungscode senden",
    "sending": "Wird gesendet...",
    "reset_password_action": "Passwort zurücksetzen",
    "resetting": "Wird zurückgesetzt...",
    "create_account": "Konto erstellen",
    "welcome": "Willkommen bei OneVerse",
    "remember_password": "Passwort erinnern?",
    "confirmation_code": "Bestätigungscode",
    "confirmation_code_placeholder": "Code aus E-Mail oder SMS eingeben",
    "new_password": "Neues Passwort",
    "new_password_placeholder": "Neues Passwort eingeben",
    "confirm_password": "Neues Passwort bestätigen",
    "confirm_password_placeholder": "Neues Passwort bestätigen",
    "mfa": {
      "code": "Code",
      "back_to_login": "Zurück zur Anmeldung",
      "sms_placeholder": "Code eingeben, der an Ihr Telefon gesendet wurde",
      "email_placeholder": "Code eingeben, der an Ihre E-Mail gesendet wurde",
      "totp_placeholder": "Code aus Ihrer Authentifizierungs-App eingeben"
    },
    "show_password": "Passwort anzeigen",
    "hide_password": "Passwort verbergen",
    "errors": {
      "invalid_credentials": "Ungültige E-Mail-Adresse oder ungültiges Passwort.",
      "account_locked": "Ihr Konto wurde gesperrt. Bitte wenden Sie sich an den Support.",
      "session_expired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
      "email_required": "E-Mail-Adresse ist erforderlich",
      "email_password_required": "E-Mail-Adresse und Passwort sind erforderlich",
      "all_fields_required": "Alle Felder sind erforderlich",
      "passwords_dont_match": "Passwörter stimmen nicht überein",
      "unexpected": "Ein unerwarteter Fehler ist aufgetreten",
      "server_non_json": "Server hat eine Nicht-JSON-Antwort zurückgegeben. Konsole prüfen."
    },
    "welcome_back": "Willkommen zurück",
    "subtitle": "Bitte geben Sie Ihre Daten ein.",
    "no_account": "Kein Konto?",
    "sign_up": "Registrieren"
  },
  "dashboard": {
    "welcome": "Willkommen, {{name}}",
    "new_submission": "Neue Einreichung",
    "submission_overview": "Einreichungsübersicht",
    "view_all_submissions": "Alle Einreichungen anzeigen",
    "recent_activity": "Letzte Aktivität",
    "no_recent_activities": "Keine aktuellen Aktivitäten.",
    "search_placeholder": "Suchen",
    "total": "Gesamt",
    "submission_singular": "Einreichung",
    "submission_plural": "Einreichungen",
    "active_site_status": "Status aktiver Standorte",
    "view_study": "Studie anzeigen",
    "loading_studies": "Studien werden geladen...",
    "select_study": "Studie auswählen",
    "view_details": "Details anzeigen",
    "news_and_notes": "Neuigkeiten & Notizen",
    "no_recent_posts": "Keine aktuellen Beiträge.",
    "failed_to_load_announcements": "Ankündigungen konnten nicht geladen werden",
    "statuses": {
      "response_required": "Antwort erforderlich",
      "drafts": "Entwürfe",
      "submitted": "Eingereicht",
      "pre_review": "Vorprüfung",
      "irb_review": "IRB-Prüfung",
      "post_review": "Nachprüfung",
      "expiring_soon": "Läuft bald ab"
    }
  },
  "submissions": {
    "title": "Einreichungen",
    "new": "Neue Einreichung",
    "empty": "Keine Einreichungen gefunden.",
    "status": {
      "pending": "Ausstehend",
      "under_review": "In Prüfung",
      "approved": "Genehmigt",
      "rejected": "Abgelehnt",
      "revisions_required": "Überarbeitungen erforderlich",
      "withdrawn": "Zurückgezogen",
      "expired": "Abgelaufen",
      "closed": "Geschlossen",
      "draft": "Entwurf",
      "submitted": "Eingereicht",
      "pre_review": "Vorprüfung",
      "irb_review": "IRB-Prüfung",
      "post_review": "Nachprüfung",
      "response_required": "Antwort erforderlich",
      "expiring_soon": "Läuft bald ab",
      "complete": "Abgeschlossen",
      "deleted": "Gelöscht"
    },
    "fields": {
      "title": "Titel",
      "protocol_number": "Protokollnummer",
      "principal_investigator": "Hauptprüfer",
      "submitted_at": "Eingereicht",
      "updated_at": "Zuletzt aktualisiert",
      "status": "Status",
      "type": "Typ",
      "id": "ID",
      "submitted": "Eingereicht",
      "expiration": "Ablaufdatum"
    },
    "actions": {
      "view": "Einreichung anzeigen",
      "edit": "Einreichung bearbeiten",
      "withdraw": "Zurückziehen",
      "submit": "Zur Prüfung einreichen"
    },
    "empty_yet": "Noch keine Einreichungen.",
    "search_placeholder": "Nach ID oder Titel suchen",
    "filter": {
      "all_statuses": "Alle Status",
      "all_types": "Alle Typen",
      "status_label": "Status",
      "type_label": "Typ"
    },
    "errors": {
      "failed_to_load": "Einreichungen konnten nicht geladen werden"
    }
  },
  "studies": {
    "title": "Studien",
    "new": "Neue Studie",
    "empty": "Keine Studien gefunden.",
    "fields": {
      "title": "Studientitel",
      "irb_number": "IRB-Nummer",
      "pi": "Hauptprüfer",
      "status": "Status",
      "start_date": "Startdatum",
      "end_date": "Enddatum",
      "id": "ID",
      "type": "Typ",
      "submitted": "Eingereicht",
      "expiration": "Ablaufdatum"
    },
    "empty_yet": "Noch keine Studien.",
    "search_placeholder": "Nach ID oder Titel suchen",
    "filter": {
      "all_statuses": "Alle Status",
      "all_types": "Alle Typen",
      "type_label": "Typ",
      "attribute_label": "Attribut",
      "all_attributes": "Alle Attribute",
      "attribute_value_placeholder": "Attributwert"
    },
    "errors": {
      "failed_to_load": "Studien konnten nicht geladen werden"
    },
    "standalone": "eigenständig",
    "sort_by": "Sortieren nach {{column}}",
    "attributes": {
      "cro": "CRO",
      "sponsor": "Sponsor",
      "pi": "PI",
      "pi_email": "PI-E-Mail",
      "poc": "POC",
      "poc_email": "POC-E-Mail",
      "poc_phone": "POC-Telefon",
      "poc_role": "POC-Rolle"
    }
  },
  "sites": {
    "title": "Standorte",
    "new": "Neuer Standort",
    "empty": "Keine Standorte gefunden.",
    "empty_yet": "Noch keine Standorte.",
    "search_placeholder": "Nach ID, Standortname oder PI suchen",
    "filter": {
      "all_statuses": "Alle Status",
      "all_countries": "Alle Länder",
      "country_label": "Land"
    },
    "errors": {
      "failed_to_load": "Standorte konnten nicht geladen werden"
    },
    "fields": {
      "id": "ID",
      "site_name": "Standortname",
      "country": "Land",
      "protocol_number": "Protokollnummer",
      "sponsor_name": "Sponsorname",
      "pi_name": "Name des Hauptprüfers",
      "approved": "Genehmigt",
      "expiration": "Ablaufdatum",
      "status": "Status"
    }
  },
  "errors": {
    "not_found": "Die angeforderte Ressource wurde nicht gefunden.",
    "unauthorized": "Sie sind nicht berechtigt, diese Aktion durchzuführen.",
    "server_error": "Ein Serverfehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
    "network_error": "Ein Netzwerkfehler ist aufgetreten. Bitte überprüfen Sie Ihre Verbindung.",
    "not_found_title": "Wir haben diese Seite verloren",
    "not_found_body": "Die gesuchte Seite existiert nicht oder wurde verschoben.",
    "go_back": "Zurück"
  },
  "pagination": {
    "previous": "Zurück",
    "next": "Weiter",
    "page": "Seite {{current}} von {{total}}",
    "showing": "Anzeige {{from}}–{{to}} von {{total}}"
  },
  "dates": {
    "today": "Heute",
    "yesterday": "Gestern",
    "just_now": "Gerade eben",
    "ago": "Vor {{time}}"
  },
  "entity": {
    "status": {
      "in_progress": "In Bearbeitung",
      "active": "Aktiv",
      "rejected": "Abgelehnt",
      "suspended": "Gesperrt",
      "closed": "Geschlossen",
      "expired": "Abgelaufen"
    }
  },
  "activities": {
    "submission_approved": "Einreichung genehmigt",
    "submission_created": "Einreichung erstellt",
    "submission_submitted": "Einreichung eingereicht",
    "submission_updated": "Einreichung aktualisiert",
    "submission_withdrawn": "Einreichung zurückgezogen",
    "submission_rejected": "Einreichung abgelehnt",
    "submission_expired": "Einreichung abgelaufen",
    "study_created": "Studie erstellt",
    "study_updated": "Studie aktualisiert",
    "site_created": "Standort erstellt",
    "site_updated": "Standort aktualisiert",
    "status_changed": "Status geändert",
    "review_started": "Überprüfung gestartet",
    "review_completed": "Überprüfung abgeschlossen",
    "comment_added": "Kommentar hinzugefügt",
    "document_uploaded": "Dokument hochgeladen",
    "response_required": "Antwort erforderlich"
  }
}
